import React from 'react';
import RecentOrdersTable from './RecentOrdersTable';
import type { RecentOrder } from '../../services/dashboardService';

interface RecentActivitySectionProps {
  data: RecentOrder[];
  loading?: boolean;
}

export const RecentActivitySection: React.FC<RecentActivitySectionProps> = ({
  data,
  loading = false,
}) => {
  return (
    <section className="dashboard-section dashboard-recent-section">
      <RecentOrdersTable data={data} loading={loading} />
    </section>
  );
};
